module.exports = __webpack_public_path__ + "media/images/logo-where-blue02-6ea0f16d543afec8d065df5f939038ed.svg";